export default __webpack_public_path__ + "static/media/sailor-img-0.90c53fd6.png";